(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/toConsumableArray', '../core/convert', '../util/lang'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/toConsumableArray'), require('../core/convert'), require('../util/lang'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.toConsumableArray, global.convert, global.lang);
    global.convertArrayMethod = mod.exports;
  }
})(this, function (exports, _toConsumableArray2, _convert, _lang) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.convertArrayMethod = undefined;

  var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var toArray = function toArray(array) {
    if ((0, _lang.isNil)(array)) return [];
    if (Array.isArray(array)) return array;
    return [array];
  };

  var toArrayCopy = function toArrayCopy(array) {
    if ((0, _lang.isNil)(array)) return [];
    if (Array.isArray(array)) return [].concat((0, _toConsumableArray3.default)(array));
    return [array];
  };

  var callMethodReturnResult = function callMethodReturnResult(array, method, args) {
    return array[method].apply(array, (0, _toConsumableArray3.default)(args));
  };

  var callMethodReturnArray = function callMethodReturnArray(array, method, args) {
    array[method].apply(array, (0, _toConsumableArray3.default)(args));
    return array;
  };

  /**
   * Converts an Array method.
   * @memberof array
   * @param {string} method Array method name.
   * @param {boolean} [mutating=true] Whether the method mutates the array.
   * @return {function} Returns the wrapped function.
   * @see {@link core.convert|convert} for more information.
   * @since 0.2.0
   * @private
   */
  var convertArrayMethod = function convertArrayMethod(method) {
    var mutating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var getArray = mutating ? toArrayCopy : toArray;
    var callMethod = mutating ? callMethodReturnArray : callMethodReturnResult;
    return (0, _convert.convert)(function (value) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return callMethod(getArray(value), method, args);
    });
  };

  exports.convertArrayMethod = convertArrayMethod;
});